export default function FinalCta() {
  return (
    <section className="relative py-20 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Diverse%20collection%20of%20fashion%20products%20including%20bags%20accessories%20and%20clothing%20beautifully%20arranged%20on%20minimalist%20shelves%2C%20warm%20golden%20sunlight%2C%20cream%20walls%2C%20lush%20green%20plants%2C%20clean%20modern%20boutique%20aesthetic%2C%20professional%20product%20lifestyle%20photography%2C%20airy%20atmosphere%2C%20warm%20neutral%20tones%2C%20soft%20natural%20highlights&width=1600&height=600&seq=allchinabuy-cta-v2&orientation=landscape"
        alt="AllChinaBuySpreadsheet product categories showcase"
        title="AllChinaBuySpreadsheet – Start Sourcing Today"
        className="absolute inset-0 w-full h-full object-cover"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>
      <div className="relative z-10 px-4 md:px-6 max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-white mb-4">
          Start Using AllChinaBuySpreadsheet Today
        </h2>
        <p className="text-base md:text-lg text-white/85 mb-8 max-w-xl mx-auto leading-relaxed">
          Access the most structured China sourcing spreadsheet database and start making smarter
          buying decisions with verified supplier data.
        </p>
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center px-8 py-3.5 text-base font-semibold rounded-lg bg-primary-500 text-white hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
        >
          <i className="ri-database-2-line mr-2"></i>
          Open Spreadsheet Hub
        </a>
      </div>
    </section>
  );
}